export default {"src":"/_next/static/media/paypal.77d83f25.svg","height":48,"width":170};